import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";
const type = 'DIAGNOSIS';

export const diagnosisAPI = createStaticResourceAPI({
    baseURL: `${process.env.REACT_APP_GLOBO_API}/staticdata/diagnosis`,
    resource: "Diagnosis",
    idKey: "diagnosisId",
    tagTypes: ["GLOBO", "Diagnosis"],
    lookupMap: ({ diagnosisId, diagnosisName }) => ({
        value: diagnosisId,
        label: diagnosisName,
    }),
    getInvalidationTags: ({ mode, patch }) => {
        const tags = [{ type: type, id: type }];
        if (mode === 'save' || mode === 'delete') {
            tags.push({ type: type, id: patch.diagnosisId });
        }
        return tags; 
    },
});

export const {
    useGetDiagnosisQuery,
    useFindDiagnosisQuery,
    useLookUpDiagnosisMutation,
    useDeleteDiagnosisMutation,
    useSaveDiagnosisMutation,
    useExportDiagnosisMutation,
} = diagnosisAPI;
